/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 03:59 pm
 * Last Modified: Monday, 24-07-22 05:24 pm, by Harper Yan
 */

import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type BreadcrumbsThemeOptions = {
  defaultProps?: ComponentsProps['MuiBreadcrumbs'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiBreadcrumbs'];
  variants?: ComponentsVariants<Theme>['MuiBreadcrumbs'];
};

export const MuiBreadcrumbs: BreadcrumbsThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      // padding: '8px 0',
    }),
    separator: () => ({
      margin: '0 2px',
    }),
  },
};
